import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mx-4" },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("app-alert", {
                attrs: {
                  icon: "warning",
                  message:
                    "Atenção, servidor! Utilize com moderação os extremos da escala.",
                  type: "error",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("app-title", { attrs: { texto: _vm.titulo } }),
              _c("avaliacao-status", {
                attrs: {
                  avaliando: _vm.prazoAtual && !_vm.concluido,
                  status: _vm.avaliacoesFinalizadas,
                },
              }),
              _c("legenda-escala-avaliacao", {
                attrs: { escalas: _vm.escalas },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.prazoAtual && !_vm.concluido
        ? _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c(_vm.avaliacaoForm, {
                    tag: "component",
                    attrs: {
                      avaliacoes: _vm.avaliacoes,
                      lista: _vm.lista,
                      escalas: _vm.escalas,
                      tipo: _vm.tipo,
                      perspectiva: _vm.perspectiva,
                    },
                    on: { done: () => (_vm.concluido = true) },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        VRow,
        [_c(VCol, { attrs: { cols: "12" } }, [_vm._t("default")], 2)],
        1
      ),
      !_vm.prazoFuturo
        ? _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c("avaliacao-list", {
                    attrs: {
                      avaliacoes: _vm.avaliacoes,
                      lista: _vm.lista,
                      escalas: _vm.escalas,
                      tipo: _vm.tipo,
                      perspectiva: _vm.perspectiva,
                      disabled: !_vm.prazoAtual,
                      "is-avaliacao-gestores": _vm.isAvaliacaoGestores,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.prazoAtual && _vm.lista.length > 0 && !_vm.avaliacoesFinalizadas
        ? _c(
            VRow,
            { staticClass: "justify-end", attrs: { "no-gutters": "" } },
            [
              _c(VSpacer),
              _c(
                VTooltip,
                {
                  attrs: { disabled: !_vm.concluido, left: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              VBtn,
                              _vm._g(
                                {
                                  attrs: {
                                    disabled: !_vm.concluido,
                                    color: "secondary",
                                    outlined: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.finalizar()
                                    },
                                  },
                                },
                                on
                              ),
                              [
                                _vm._v(" Finalizar "),
                                _c(VIcon, { staticClass: "ml-2" }, [
                                  _vm._v("check"),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2788226480
                  ),
                },
                [
                  _c("span", [
                    _vm._v("Clique no botão para finalizar a avaliação"),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("dialog-agradecimento", {
        attrs: {
          descricao: _vm.dialogAgradecimento.descricao,
          "dialog-visible": _vm.dialogAgradecimento.visibilidade,
          "toogle-visible": _vm.toogleDialogAgradecimento,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }